export const getUniqueImageUrl = (url: string, isCurrentConfigNexudus: boolean): string => {
  return isCurrentConfigNexudus ? url : `${url}?${new Date().getTime()}`;
};
